import { render, staticRenderFns } from "./Verdok.vue?vue&type=template&id=38a575a7&scoped=true&"
import script from "./Verdok.vue?vue&type=script&lang=js&"
export * from "./Verdok.vue?vue&type=script&lang=js&"
import style0 from "./Verdok.vue?vue&type=style&index=0&id=38a575a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a575a7",
  null
  
)

export default component.exports